import { render, staticRenderFns } from "./DetailsContent.vue?vue&type=template&id=22bd0e24&scoped=true&"
import script from "./DetailsContent.vue?vue&type=script&lang=ts&"
export * from "./DetailsContent.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsContent.vue?vue&type=style&index=0&id=22bd0e24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bd0e24",
  null
  
)

export default component.exports